import React from "react";
import CoinIcon from "../../../assets/images/coin-icon.png";
import PayWallet from "../../../assets/images/icon-wallet.png";
import { Link } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";

import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const profileContent = () => {
  return (

    <div className="main-content-left create-profile-content">
      <div className="top-content">
        <div className="left-content">
          <div class="Digant-Bhatt">Welcome</div>
         
        </div>

        <div className="right-icon-content">
          <PersonIcon className="person-icon" />
        </div>
      </div>

     
    </div>
  );
};

export default profileContent;
